exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.item-list[data-v-b9a6ae3a] {\n  border-bottom: 1px solid;\n  border-color: #cfcfcf;\n}\n.remove-icon[data-v-b9a6ae3a] {\n  color: #d2d2d2;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b9a6ae3a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/cart/ListCart.vue
// module id = 414
// module chunks = 1